import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/_components/Shared/GratuityCalculator/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/_components/Shared/Posts/index.jsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_1_1.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_1_2.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_10_1.webp");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_10_2.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_11_1.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_11_2.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_12_1.webp");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_12_2.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_13_1.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_14_1.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_14_2.webp");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_15_1.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_15_2.jpeg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_16_1.jpeg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_16_2.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_17_1.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_17_2.webp");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_18_1.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_18_2.webp");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_19_1.jpeg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_2_1.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_2_2.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_20_1.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_20_2.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_21_1.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_3_1.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_3_2.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_4_1.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_4_2.jpeg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_5_1.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_5_2.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_6_2.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_7_1.jpeg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_7_2.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_8_1.jpeg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_9_1.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts1/Blog_9_2.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/1.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/10.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/11.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/12.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/13.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/14.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/15.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/16.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/17.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/18.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/19.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/2.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/20.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/3.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/4.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/5.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/6.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/7.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/8.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts2/9.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/1.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/10.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/11.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/12.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/13.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/14.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/15.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/16.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/17.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/18.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/19.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/2.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/20.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/21.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/3.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/4.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/5.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/6.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/7.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/8.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts3/9.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts4/1.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts4/10.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts4/3.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts4/4.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts4/5.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts4/6.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts4/7.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts4/8.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts4/9.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts5/1.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts5/2.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts5/3.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts5/4.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts5/5.jpeg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts5/6.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/posts/posts5/8.jpg");
